import {
  Highlights,
  WtpBlue,
  Deadline,
  Red,
  Title,
  List,
  Item,
  Description,
  Bold,
  SectionHeader,
  DTitle,
  Diamond,
  DLine,
} from "./commonDraw";

const En = {
  aboutPage: {
    title: <> About Us</>,
    about_1: (
      <>
      Since its establishment in 2010, WEthePEOPLE Law Group has handled corporate advisory matters, competition and corporate disputes, and intellectual property matters. For technology companies, we review technology rights protection and commercialization, cross-border transactions, U.S. business and litigation, and customs and trade issues from both advisory and dispute-resolution perspectives. <br />
        <br />
      Our practices are organized into four areas: (1) Technology Company Advisory, (2) IP & Technology Rights Strategy, (3) Global Expansion & Export Advisory, and (4) U.S. Business & Litigation. Because these issues often intersect in real-world business operations, we review related areas together when appropriate.<br />
        <br />
    A single technology-business agreement may involve investment and governance, ownership and licensing of IP, customs clearance, export controls, and potential disputes under U.S. law. Rather than viewing each issue in isolation, WEthePEOPLE identifies what should be reviewed and implemented first based on the client’s business model, technology assets, counterparties, and target markets. <br />
        <br />
       We focus on industries in which technology and intangible assets are central, including gaming and content, AI and software, semiconductors and electronics, mobility and batteries, and digital assets. Even where a matter spans multiple disciplines or jurisdictions, WEthePEOPLE communicates directly with the client’s Korean headquarters and leads the engagement so that Korean advice and overseas procedures proceed in a consistent direction.
        <br />
       
      </>
    ),

    feature_1_title: `Connecting Technology and Industry through IP Expertise`,

    feature_1_text: `In collaboration with Lee International IP & Law, Lucid Insights, Creative Answers (LICA), and WethePeople IP & Law, we deliver integrated IP services spanning patents, trademarks, and copyrights. From global portfolio development to U.S. patent filings and prosecutions, our one-stop system supports every stage of the process. By aligning technology with industry, we drive innovation and enhance our clients’ competitiveness.`,
    feature_2_title: `Empowering the Game Industry through Legal Insight & Collaboration`,
    feature_2_text: `Our expertise covers content licensing, protection of IP and trade secrets, and compliance for domestic and global publishing. Partnering with WEthePEOPLE Plus Game Consulting, QROAD, the Korea Mobile Game Association, and the Korea AI Game Association, we provide legal and business support that bridges industry practice with regulatory compliance.`,
    feature_3_title: `Leader in International Litigation, Advocating with Justice & Humanity`,
    feature_3_text: `For over 15 years, we have led major international litigation to protect the rights of global companies and individuals. In close partnership with Hausfeld, a world-renowned international litigation law firm, we offer unmatched expertise in this field.`,
    feature_4_title: `China Desk – Strategic Partner for Korea–China Business `,
    feature_4_text: `With Chinese-qualified attorneys, native Chinese professionals, and a strong local network, we provide strategic guidance for Chinese companies entering Korea and Korean companies expanding into China. 
Our cross-border expertise in investment, joint ventures, and IP helps clients navigate complex legal and business challenges between the two markets. `,
  },
  samplePage: {
    title: (
      <>
        <Highlights>
          WethePeople Law Group Supports Developers{" "}
          <span style={{ whiteSpace: "nowrap" }}>
            {" "}
            in Recovering Losses from
          </span>
          <br />
          Google & Apple’s Excessive In-App Fees!
        </Highlights>
      </>
    ),
    subTitle: (
      <>
        {" "}
        Join the class settlement to claim compensation for unfairly charged
        fees.
        <br />
        There is{" "}
        <WtpBlue>
          no cost to participate, and the process follows a “No Win, No Fee”
          model.{" "}
        </WtpBlue>
        Together with Hausfeld LLP, a U.S. law firm specializing in antitrust
        and class actions, WethePeople is pursuing a successful compensation
        process.
      </>
    ),
    deadline: (
      <>
        <Highlights>Extended Application Deadline: May 31, 2025</Highlights>
        <br /> (Damage assessments will be conducted in the order applications
        are received.)
      </>
    ),
    applyBt: <>Apply Now</>,
    learnMore: <>Learn More</>,

    section_1_title: `Class Action Overview`,

    section_1_dec_1: (
      <>
        This collective mediation addresses the harm suffered by Korean app
        developers due to <WtpBlue>unfair practices</WtpBlue> by Google and
        Apple—such as imposing a 30% in-app payment commission by abusing their{" "}
        <WtpBlue>market dominance</WtpBlue>
      </>
    ),
    section_1_dec_2: (
      <>
        {" "}
        WethePeople Law Office is collaborating with{" "}
        <WtpBlue>Hausfeld LLP</WtpBlue>, a renowned U.S. law firm with extensive
        class action experience, to pursue{" "}
        <WtpBlue>a pre-litigation settlement</WtpBlue> on behalf of affected
        developers.
      </>
    ),
    section_1_dec_3: (
      <>
        Hausfeld successfully secured compensation from Google in 2023 for over
        <WtpBlue> 48,000 U.S. app developers</WtpBlue> in a similar case.
      </>
    ),
    section_1_dec_4: <></>,
    section_1_dec_5: (
      <>It’s time for developers to unite and assert their legitimate rights.</>
    ),
    section_2_title: <>Who Can Apply</>,
    section_2_dec: (
      <>
        Any <WtpBlue>individual or corporate app developer,</WtpBlue> domestic
        or international, may participate if:
      </>
    ),

    section_2_li_1: (
      <>
        You distributed apps (including games) via{" "}
        <WtpBlue>Google Play Store or Apple App Store,</WtpBlue> and
      </>
    ),

    section_2_li_2: (
      <>
        You used <WtpBlue>Google or Apple’s in-app payment system,</WtpBlue>{" "}
        incurring platform commission fees.
      </>
    ),
    section_3_title: <>Why You Should Participate</>,
    section_3_li_1: (
      <>
        <WtpBlue>No Financial Risk:</WtpBlue> There are no upfront or
        participation costs. The entire process operates on a contingency fee
        basis ("No Win, No Fee")
      </>
    ),
    section_3_li_2: (
      <>
        {" "}
        <WtpBlue>Strong Compensation Potential:</WtpBlue> With legal expertise
        from Hausfeld—who led a successful U.S. settlement—you can expect a
        well-supported claim for damages.
      </>
    ),
    section_3_li_3: (
      <>
        {" "}
        <WtpBlue>Professional Valuation:</WtpBlue> Damages will be calculated
        through independent expert assessment, ensuring compensation reflects
        real losses.
      </>
    ),
    section_3_li_4: (
      <>
        {" "}
        <WtpBlue>Combined Legal Force:</WtpBlue> Korean legal professionals from
        WethePeople and international experts at Hausfeld LLP jointly represent
        your interests.
      </>
    ),
    section_3_li_5: (
      <>
        {" "}
        <WtpBlue>Policy Reform Impact:</WtpBlue> Beyond compensation, your
        participation could spark reforms toward fairer platform commission
        policies.
      </>
    ),
    section_3_li_6: (
      <>
        {" "}
        <WtpBlue>Power of Collective Action:</WtpBlue> By joining a large group
        of claimants, you avoid the burden of solo litigation while increasing
        pressure for resolution.
      </>
    ),
    section_4_title: <>Concerned About Platform Retaliation?</>,

    section_4_des_1: (
      <>
        {" "}
        <WtpBlue>
          This process is governed by U.S. law under developer agreements with
          Google and Apple, ensuring participating developers are protected
          under U.S. court jurisdiction.
        </WtpBlue>
      </>
    ),
    section_4_des_2: (
      <>
        To date, tens of thousands of developers have participated in similar
        U.S. actions, with zero reported cases of retaliation.
      </>
    ),
    section_4_li_1: <>Google Class Action: ~48,000 U.S. app developers </>,
    section_4_li_2: <>Apple Class Action: ~67,000 U.S. app developers </>,
    section_4_li_3: <>U.S. consumer settlement: approx. KRW 910 billion </>,

    section_4_des_3: <> Total app-related settlements: over KRW 1.1 trillion</>,
    section_4_des_4: (
      <>
        {" "}
        <WtpBlue>U.S. Antitrust Law (Sherman Act) </WtpBlue>{" "}
      </>
    ),
    section_4_des_4_5: (
      <>
        Retaliation by dominant platforms is itself a violation of U.S.
        antitrust law.{" "}
      </>
    ),
    section_4_des_5: (
      <>
        {" "}
        Criminal Penalties: Up to $100 million in fines or up to 10 years’
        imprisonment per offense
      </>
    ),
    section_4_des_6: (
      <>Civil Penalties: Up to triple (3x) damages in punitive compensation </>
    ),
    section_4_des_7: (
      <>
        {" "}
        <WtpBlue>U.S. Court Precedents</WtpBlue>
      </>
    ),
    section_4_des_8: <> While businesses may choose partners freely,</>,
    section_4_li_4: (
      <>
        {" "}
        any action that interferes with litigation or maintains monopolistic
        control is unlawful.
      </>
    ),
    section_4_li_5: (
      <>
        {" "}
        If platforms retaliate—via account termination, access restriction, or
        business disruptio
      </>
    ),

    section_4_des_9: (
      <> U.S. courts may issue immediate injunctions to stop such acts.</>
    ),
    section_5_title: <> Application Process</>,
    section_5_sub: (
      <> (U.S. collective action process — typically 6 to 12 months)</>
    ),
    section_5_table: [
      {
        title: "Online Submission",
        description:
          "Submit your basic developer information via our official application form.",
      },
      {
        title: "Review & Consultation",
        description:
          "WethePeople will contact you to review your application and collect supporting documentation.",
      },
      {
        title: "Damage Assessment",
        description:
          "Hausfeld LLP will review and appraise your damages based on submitted financial records and transaction data.",
      },
      {
        title: "Settlement Negotiation",
        description: `WethePeople and Hausfeld will represent your case in pre-suit settlement negotiations with Google and Apple. 
  (Mediator: Layn Phillips, former U.S. federal judge)`,
      },
      {
        title: "Compensation & Notification",
        description:
          "Once settlement is reached, developers will be notified individually, and compensation will be distributed accordingly.",
      },
    ],
    section_6_title: "How to Apply",
    section_6_des_1: (
      <>
        Deadline: <Deadline>May 31, 2025 </Deadline>{" "}
      </>
    ),
    section_6_des_2: <>(assessed in order of submission)</>,
    section_6_des_3: (
      <>Click the button below to begin your application today.</>
    ),
    section_6_des_4: "Apply Now",

    section_6_des_5: (
      <>
        {" "}
        After submission, our team will reach out to verify details and begin
        processing.
      </>
    ),
    section_7_title: <>Contact Information</>,
    section_7_des_1: <>If you have questions or need support:</>,
    section_7_des_2: (
      <>
        <WtpBlue>Contact:</WtpBlue> Young-Ki Rhee, U.S. Attorney, WethePeople
        Law Office
      </>
    ),
    section_7_des_3: (
      <>
        {" "}
        <WtpBlue>Phone:</WtpBlue> +82 2 2285 0062
      </>
    ),
    section_7_des_4: <WtpBlue>Email</WtpBlue>,
    section_7_des_4_5: <WtpBlue>Application Page</WtpBlue>,
    section_7_des_5: <></>,
    section_7_des_6: "https://wtplaw.co.kr/en/app_apply",
  },

  apply: {
    m: "To proceed, please ensure that you have entered a valid email address.",
    file: "Please note that only files smaller than 5MB may be uploaded.",
    alert:
      "We appreciate your interest in our services. Your consultation request has been successfully received, and a representative will reach out to you shortly.",
    title: "Application for Collective Mediation Consultation",
    A_1: (
      <>
        <Red>[Required]</Red> Company Name(Korean)
      </>
    ),
    A_2: <>[Optional] Company Name(English)</>,
    A_3: (
      <>
        {" "}
        [Corporation] Must match the English name on the Certificate of
        Incorporation{"\n"}
        [Sole Proprietor] Must match the registered English business name
      </>
    ),
    A_4: (
      <>
        {" "}
        <Red>[Required]</Red> Representative(Korean)
      </>
    ),
    A_5: <>[Optional] Representative(English)</>,
    A_6: <>Must match the name on passport</>,
    A_7: (
      <>
        {" "}
        <Red>[Required]</Red> Contact Person Name
      </>
    ),
    A_8: (
      <>
        <Red>[Required]</Red> Mobile Phone Number
      </>
    ),
    A_9: <>[Optional] Office Phone Number</>,
    A_10: (
      <>
        <Red>[Required]</Red> Email Address
      </>
    ),

    A_11: <>[Attachment] Power of Attorney Form</>,
    A_12: <>Download</>,
    A_13: <> [Select] [Documents to be submitted] [Upload]</>,
    A_13_5: <> Upload</>,
    A_14: <>No file selected</>,
    A_15: <> * Alternatively, you may submit via email{" \n"}</>,
    A_16: (
      <>
        {" "}
        Consent to Collection and Use of Personal Information
        <br />
        Items Collected: Name / Company Name, Phone Number, Email
        <br />
        Purpose: For consultation in connection with the collective mediation
        process
        <br />
        Retention Period: Retained until one year after the conclusion of the
        mediation, then destroyed
        <br />
        You may refuse to consent; however, refusal may limit your ability to
        submit the application.
      </>
    ),
    A_17: <>Submit Application</>,
  },

  footer: {
    mainTitle: `WEthePEOPLE Law Group`,
    mainText_1: `The word “WE – 위(爲)” in our name reflects our commitment to act for our clients—with dedication, integrity, and purpose.
                  `,
    mainText_2: `
                  We are here to be your trusted legal and business partner.`,
    tel: `Office`,
    map: `7F, Jinyang Building, 47 Gyeongui-daero, Seodaemun-gu, Seoul, Korea`,
    phone: `+82-2-2101-0750`,
    sub: `WEthePEOPLE In-App Payment Response Center`,
    subMap_1: `#704, Ace Technotower V, 20 Digital-ro 31-gil, `,
    subMap_2: `Guro-gu, Seoul, Korea`,
    fax: `Fax`,
    subp_1: "+82-70-4699-0107 ",
    subp_2: "+82-10-8485-5743",
    subp_3: "+82-50-4171-8975",
  },
  header: {
    nav: {
      home: "Home",
      intro: "About Us",
      practice: "Practices",
      member: "Professionals",
      notice: "Announcements",
      international: "CSV Litigation Center",
      monetization: "IP Monetization Center",
      news: "News",
      cases: "Key Cases",
      insight: "Insights",
      Partners: "Family Site",
      wethepeople: "WethePeople IP",
      pharos: "PHAROS LABOR LAWFIRM",
      game: "Korea Mobile Game Association",
      indie: "KOREA AI GAME ASSOCIATION",
      updates: "Updates",
      publications: "Publications",
      newsletters: "Newsletters",
      recruit: "Ongoing Cases",
      track: "Key Track Record",
      contact: "Contact",
    },
  },
  homepage: {
    slider: [
      {
        id: 1,
        backgroundImage: "/images/home/main_1.png",
        title: "Your Trusted Legal Partner with Proven Expertise",
        subtitle:
          "WEthePEOPLE Law Group delivers top-tier legal services across intellectual property, corporate law, litigation, and more.",
        buttonText: "법률 상담 문의하기",
        buttonLink: "/contact",
      },
      {
        id: 2,
        backgroundImage: "/images/home/main_5.png",
        title: "A Global Team of Legal Experts with Specialized Insight",
        subtitle:
          "We provide tailored solutions to complex legal challenges in both domestic and international settings.",
        buttonText: "더 알아보기",
        buttonLink: "/about",
      },
      {
        id: 3,
        backgroundImage: "/images/home/main_3.png",
        title: "Dedicated to Protecting Your Rights and Achieving Your Success",
        subtitle:
          "The word “WE – 위(爲)” in our name reflects our commitment to act for our clients—with dedication, integrity, and purpose.",
        buttonText: "성공 사례 보기",
        buttonLink: "/cases",
      },
    ],
    search: "Search",
    searchEx: "Search",
    searchBt: "Search",
    popImage: "/images/event/popup_en_new.png",
  },
  PracticeAreasPage: {
    title: "Expertise",
    practice: "Practice Areas",
    special: "Core & Specialized Services",
    normal: "General Corporate Legal Services",
    sector: "Industries",
    learnMore: "Learn More",
  },
  PracticeAreasDetailPage: {
    home: "Home",
    area: "Expertise",
    introduction: "Overview",
    service: "Service",
  },
  memberPage: {
    professionals: "Professionals",
    proSearch: "Professional Search",
    search: "Search",
    holder: "Search",
  },
  memberDetailPage: {
    home: "Home",
    member: "Professionals",
    intro: "Introduction",
    history: "Experience",
    education: "Education",
    performance: "Representative Cases",
    lan: "Language",
    insight: "Insights",
    awards: "Awards & Recognitions",
    qualifications: "Qualifications",
  },
  noticePage: {
    home: "Announcements",
  },
  noticeDetailPage: {
    home: "Home",
    announcements: "Announcements",
    backtoList: "Back to List",
    previous: "Previous",
    next: "Next",
  },
  casePage: {
    home: "Key Track Record",
  },
  caseDetailPage: {
    home: "Home",
    keyCases: "Key Track Record",
    backtoList: "Back to List",
    previous: "Previous",
    next: "Next",
  },

  internationalPage: {
    title: "CSV Litigation Center",
    overview: (
      <>
        Creating Shared Value (CSV) refers to the concept that corporate
        economic value creation and the advancement of social value are not in
        conflict. Rather, as companies improve the economic and social
        environment in which they operate, the value of both the company and its
        shareholders can grow together. CSV represents a management strategy
        through which companies contribute to solving social problems while
        achieving sustainable economic performance. In an era where ESG-oriented
        management is increasingly emphasized, the importance of CSV continues
        to grow.
        <br />
        <br />
        The CSV Litigation Center of WethePeople Law Group seeks to implement
        the CSV concept within the realm of litigation. Corporate misconduct
        such as global cartels, environmental and consumer harm,
        market-disruptive practices, and data breaches undermines societal trust
        while inflicting substantial economic damage on companies and
        shareholders alike. By clearly establishing accountability for such
        violations, recurrence can be prevented and meaningful recovery can be
        achieved.
        <br />
        <br />
        The CSV Litigation Center handles large-scale damages actions,
        shareholder derivative suits, and public-interest accountability
        litigation targeting serious unlawful conduct that infringes upon the
        shared value of corporations, shareholders, and society. In addition to
        domestic litigation, the Center pursues comprehensive solutions in
        cross-border litigation matters. Ultimately, the CSV Litigation Center
        aims not merely at short-term damage recovery or resolution of
        individual disputes, but at embedding durable structures of
        accountability and compliance within corporations and markets.
      </>
    ),

    whyUs: (
      <>
        {" "}
        <Item>
          <Description>
            For over 15 years, WethePeople Law Group has accumulated substantial
            experience and meaningful results by representing clients across
            diverse industries, including large corporations, small and
            medium-sized enterprises, and individuals, in domestic and
            international courts. Our practice has focused particularly on cases
            involving domestic harm caused by unlawful conduct such as cartels
            and unfair practices by global corporations.
          </Description>{" "}
        </Item>
        <Item>
          <Description>
            Large-scale and collective litigation presents high barriers to
            entry due to procedural complexity, evidentiary challenges, and cost
            structures. The CSV Litigation Center provides strategic, end-to-end
            litigation management, encompassing plaintiff group formation,
            evidence collection and analysis, identification of multilayered
            damage structures, litigation strategy development, and
            representation through negotiation and judgment.
          </Description>{" "}
        </Item>
        <Item>
          <Description>
            Through a success-fee-based litigation structure under a “No Win, No
            Fee” arrangement, the Center ensures that clients’ legitimate rights
            are not constrained by financial barriers and remains firmly
            committed to outcome-driven representation.
          </Description>{" "}
        </Item>
        <Item>
          <Description>
            In the field of cross-border litigation, the Center works in close
            collaboration with leading international plaintiffs’ law firms,
            including Hausfeld LLP, Cohen Milstein LLP, and Saxena White P.A..
            Through these partnerships, the Center proactively designs and
            executes joint actions and collective response structures in complex
            global disputes that domestic clients would find difficult to pursue
            independently.
          </Description>
        </Item>
      </>
    ),

    services: (
      <>
        <div>
          <Title>1. Accountability Litigation for CSV Infringements</Title>
          <Item>
            <Description>
              Pursuit of liability for global cartels, unfair trade practices,
              and anticompetitive conduct
            </Description>
            <Description>
              Collective damages cases involving environmental, consumer,
              financial, and investor harm
            </Description>
          </Item>{" "}
        </div>
        <div>
          <Title>2. Protection of Shareholder and Stakeholder Rights</Title>
          <Item>
            <Description>
              Shareholder derivative actions and disputes concerning management
              accountability
            </Description>
            <Description>
              Recovery strategies for corporate value erosion resulting from
              unlawful conduct
            </Description>{" "}
          </Item>{" "}
        </div>{" "}
        <div>
          <Title>3. Collective Litigation Structuring</Title>
          <Item>
            <Description>
              Analysis of damage and liability structures and formation of
              plaintiff groups
            </Description>
            <Description>
              Evidence collection and analysis, damages assessment, and proof
              strategies
            </Description>
          </Item>{" "}
        </div>{" "}
        <div>
          <Title>4. Cross-Border Litigation and Joint Actions</Title>
          <Item>
            <Description>
              Joint litigation in cooperation with overseas law firms
            </Description>
            <Description>
              Strategic forum selection and support for global settlement
              processes
            </Description>{" "}
            <Description>
              Representation before major foreign jurisdictions, including U.S.
              state and federal courts and the ITC
            </Description>
          </Item>{" "}
        </div>
      </>
    ),
  },
  monetizationPage: {
    title: "IP Monetization Center",
    overview: (
      <>
        The IP Monetization Center of WethePeople Law Group is a specialized
        organization dedicated to designing and implementing revenue structures
        based on intellectual property rights (IPRs). IP monetization is
        generally carried out through the following two approaches:
        <Title>1. Infringement-based monetization</Title>
        <Item>
          <Description>
            which involves securing damages or royalties through litigation or
            licensing negotiations against infringers; and
          </Description>
        </Item>
        <Title>2. Transaction-based monetization</Title>
        <Item>
          <Description>
            which generates asset value and cash flow through sales or outbound
            licensing.
          </Description>
        </Item>
        These monetization approaches are strategically selected and combined
        depending on the nature of the rights and the relevant market
        environment.
        <br />
        <br />{" "}
        <SectionHeader>
          <Diamond>◆</Diamond>
          <DTitle>
            <Bold>Patent Practice</Bold>
          </DTitle>
          <DLine />
        </SectionHeader>
        Patents are not merely exclusive rights, but core business assets whose
        value can be maximized through infringement enforcement and
        transactional structures. The IP Monetization Center systematically
        manages the entire patent monetization process, including the
        identification of monetizable patents, valuation and infringement
        analysis, market and target research, litigation and negotiations, and
        the execution of transactions.
        <br />
        <br />
        In addition, the Center supports patent portfolio design strategies that
        take revenue generation into account from the R&D stage, and provides
        services related to domestic and international filings and the
        optimization of claim scope. Small and medium-sized enterprises,
        universities, and research institutions often fail to fully utilize the
        value of their patent assets or are unaware of monetization
        opportunities.
        <br />
        <br />
        Through collaboration among U.S. and Korean patent attorneys, patent
        agents, and IP professionals with experience at global technology
        companies, we conduct comprehensive analyses of clients’ patent
        portfolios and present practical and realizable monetization models.
        <br /> <br />
        <SectionHeader>
          <Diamond>◆</Diamond>
          <DTitle>
            <Bold>Trademark / Design / Copyright Practice</Bold>
          </DTitle>
          <DLine />
        </SectionHeader>
        Trademarks, designs, and copyrights are likewise business assets capable
        of generating revenue through infringement litigation, sales, and
        licensing. The IP Monetization Center realizes the economic value of
        such rights through damages claims and licensing negotiations against
        infringers, as well as IP sales and outbound licensing.
        <br />
        <br />
        Beyond enforcement and transactions, we design legal structures that
        enable IP to be monetized through brand management, content businesses,
        and derivative products and services. In doing so, we analyze scope of
        rights, revenue allocation, contractual structures, and infringement
        risks to ensure that IP utilization leads to stable and sustainable
        revenue models.
        <br />
        <br />
        We further support the expansion of existing IP into new revenue models
        across various industries, including music, film, fashion, characters,
        and performing arts, through collaborative networks with affiliated
        companies.
      </>
    ),
    whyUs: (
      <>
        {" "}
        <Item>
          <Description>
            Unlike typical Non-Practicing Entities (NPEs) that acquire patents
            and directly generate profits, we support sustainable monetization
            while allowing rights holders to retain ownership of their IP and
            pursue additional business or technological expansion.
          </Description>
        </Item>
        <Item>
          <Description>
            Our monetization structures are designed by professionals who have
            led IP strategy and U.S. patent litigation at companies such as LG,
            Samsung, and Seoul Semiconductor, ensuring close alignment with
            clients’ business strategies.{" "}
          </Description>
        </Item>
        <Item>
          <Description>
            Patent-focused U.S. attorneys and patent agents from leading
            domestic and international law firms collaborate with prominent U.S.
            patent law firms and e-discovery providers to execute high-value
            monetization projects centered on the U.S. market.
          </Description>
        </Item>
        <Item>
          <Description>
            Through cooperation with affiliated partners—including Lee
            International IP & Law, WethePeople IP & Law, and LICA Co.,
            Ltd.—comprising approximately 100 patent professionals and over 300
            engineers, we provide integrated services spanning IP analysis,
            technical validation, and transaction matching.
          </Description>
        </Item>
        <Item>
          <Description>
            Flexible fee structures, including success-based and hybrid models,
            are employed to minimize the financial burden on rights holders.
          </Description>
        </Item>
        <Item>
          <Description>
            In the areas of trademarks, designs, and copyrights, we collaborate
            with affiliated companies such as Infinite Group Co., Ltd. (CI/BI
            design specialists) and Infinis Co., Ltd. (brand management
            specialists) to design legal frameworks that enable IP-based
            business expansion.
          </Description>
        </Item>
        <Item>
          <Description>
            Drawing on over 15 years of global litigation experience, we apply
            the principles of Protection of Rights, Deterrence of Infringement,
            and Realization of Just Compensation across all aspects of our IP
            monetization practice.
          </Description>
        </Item>{" "}
      </>
    ),
    services: (
      <>
        <div>
          <Title>1. IP Portfolio Development and Strategic Design</Title>
          <Item>
            <Description>
              Design of IP portfolios with monetization objectives
            </Description>
            <Description>
              Filing strategies and optimization of claim scope, including U.S.
              direct filings, Office Actions (OA), and Continuation Applications
              (CA)
            </Description>
          </Item>{" "}
        </div>
        <div>
          <Title>2. Infringement-Based Monetization</Title>
          <Item>
            <Description>
              IP infringement analysis, market research, and target research
            </Description>
            <Description>
              Securing damages and royalties through domestic and international
              litigation and licensing negotiations
            </Description>{" "}
            <Description>
              Representation in U.S. litigation and ITC proceedings, including
              coordination with litigation funding
            </Description>
          </Item>{" "}
        </div>{" "}
        <div>
          <Title>3. Transaction-Based Monetization</Title>
          <Item>
            <Description>
              Structuring IP sales and outbound licensing transactions
            </Description>
            <Description>
              Identification and matching of potential buyers or licensees
            </Description>
            <Description>
              Contract drafting, negotiation, and legal review
            </Description>
          </Item>{" "}
        </div>{" "}
        <div>
          <Title>4. IP Commercialization and Expansion Structures</Title>
          <Item>
            <Description>
              Design of brand and content commercialization structures based on
              trademarks, designs, and copyrights
            </Description>
            <Description>
              Structuring contracts and licensing models with consideration of
              revenue allocation, rights protection, and infringement risks
            </Description>
          </Item>{" "}
        </div>{" "}
      </>
    ),
  },
  newsPage: {
    home: "News",
  },
  publicationPage: {
    home: "Publications",
    category: "Category",
    year: "Year",
    search: "Search",
    searchPlaceholder: "Search by author or title",
    all: "All",
    total: "Total",
    sampleData: "Showing sample data",
    loading: "Loading...",
    date: "Date",
    title: "Title",
    author: "Author",
    empty: "No results found.",
  },
  publicationDetailPage: {
    home: "Home",
    publications: "Publications",
    backToList: "Back to list",
    previous: "Previous",
    next: "Next",
    loading: "Loading...",
    notFound: "Publication not found.",
  },
  techHomePage: {
    familySite: "Family Site",
    nav: {
      about: "About",
      practice: "Services",
      members: "Professionals",
      insights: "Insights",
      contact: "Contact",
    },
    heroTitle: "We help technology companies grow, protect their technology rights, expand globally, and manage disputes.",
    heroText: "Centered on technology company advisory, WEthePEOPLE advises on IP and technology rights, global expansion and exports, and U.S. business and litigation. We provide the legal support needed for technology commercialization, cross-border transactions, customs and trade matters, and dispute resolution.",
    contactButton: "Request a Consultation",
    what: {
      eyebrow: "WHAT",
      title: "What We Do",
      lead: "Our practice is organized into four areas: Technology Company Advisory, IP & Technology Rights Strategy, Global Expansion & Export Advisory, and U.S. Business & Litigation.",
    },
    works: [
      { icon: "building", title: "Technology Company Advisory", text: "We support investment, contracting, organizational operations, and dispute prevention in a manner tailored to the characteristics of technology and IP." },
      { icon: "fingerprint", title: "IP & Technology Rights Strategy", text: "We advise on securing rights, technology protection, IP transactions and monetization, and domestic and international disputes." },
      { icon: "globe", title: "Global Expansion & Export Advisory", text: "We support overseas investment and cross-border transactions, customs clearance and refunds, export controls, and supply-chain regulation." },
      { icon: "scale-balanced", title: "U.S. Business & Litigation", text: "We advise on U.S. market entry and business operations, customs and trade procedures, and technology and commercial disputes." },
    ],
    who: {
      eyebrow: "WHO",
      title: "Our Professionals and Collaborative Network",
      lead: "Depending on the matter, we work with Korean attorneys, foreign attorneys, patent attorneys, customs brokers, accounting and tax professionals, and overseas law firms.",
      note: "WEthePEOPLE develops the core legal strategy and communicates directly with the client. When necessary, we collaborate with specialists in IP, customs and trade, U.S. law, and Korean corporate advisory matters, while coordinating scope, schedule, fees, and deliverables.",
    },
    network: [
      ["Korean Attorneys", "Corporate advisory, contracts, disputes and regulatory response"],
      ["Foreign Attorneys", "U.S. business and litigation, international contracts, and overseas legal advice"],
      ["Patent Attorneys", "Securing patent, trademark and design rights, technology protection, IP transactions and monetization, and disputes"],
      ["Customs Brokers", "Tariff classification, customs valuation and origin, customs clearance and refunds, customs audits, and appeals"],
      ["Overseas Law Firms", "Local-law advice, U.S. and other overseas litigation and customs procedures, and joint regulatory and dispute matters"],
      ["Accounting & Tax Professionals", "Tax advisory on overseas entities, taxation and transfer pricing, and transaction structuring"],
    ],
    whyEyebrow: "Why WEthePEOPLE",
    whyTitle: "Capabilities Tailored to Technology Business Models",
    why: [
      ["Integrated Advice for Technology Companies", "We review the business model and technology assets together and propose legal structures suited to the company’s stage of growth."],
      ["Integrated IP, U.S. Litigation & Customs Capabilities", "We address IP protection and monetization, U.S. litigation, and customs and trade matters in line with the actual flow of transactions and disputes."],
      ["WEthePEOPLE-Led Collaboration", "WEthePEOPLE develops the core legal strategy and communicates directly with the client, collaborating with Korean and overseas specialists and law firms as needed."],
    ],
    footerTitle: "Review legal challenges for technology companies with us",
    footerLead: "WEthePEOPLE is a trusted legal partner for the growth and global expansion of technology companies.",
    firmName: "WEthePEOPLE Law Group",
    address: "7F, Jinyang Building, 47 Gyeongui-daero, Seodaemun-gu, Seoul, Korea",
    tel: "+82-2-2101-0750",
    email: "wtp@wtplaw.co.kr",
    privacyLabel: "Privacy Policy",
    termsLabel: "Terms of Use",
  },
  techPracticePage: {
    title: "Practices",
    areas: [
      {
        title: "Technology Company Advisory",
        intro: "Based on a technology company’s stage of growth and business model, we advise on legal issues involving investment, contracts, organizational operations, and dispute prevention. We identify potential issues in Korean business operations in advance, taking into account the characteristics of the company’s technology and IP.",
        items: [
          ["Growth & Investment Structures", "incorporation and shareholder structures, seed and series financing, shareholders’ agreements, stock options, M&A and business transfers"],
          ["Technology Business & Strategic Agreements", "joint development and PoC, OEM/ODM and supply agreements, platform and SaaS agreements, distribution and dealership arrangements, technology transfer and licensing"],
          ["Organization & Compliance ", "boards and shareholders’ meetings, internal controls, privacy and data, employees, employee inventions, and trade secrets"],
          ["Business Risk & Dispute Prevention ", "contract diagnostics, governance, employment and transaction disputes, negotiation, mediation, and early-stage litigation strategy"],
        ],
      },
      {
        title: "IP & Technology Rights Strategy",
        intro: "We advise on securing rights in technology and brands, protecting trade secrets, IP transactions, and domestic and international enforcement. In collaboration with patent firms and patent attorneys, we help clients use IP not merely as registered rights, but as assets for transactions and commercialization.",
        items: [
          ["Technology & Brand Rights Strategy ", "invention harvesting, patent, trademark and design portfolios, domestic and international filing and registration, and scope-of-rights strategy"],
          ["Trade Secret & Technology Protection Systems ", "confidentiality management, employee inventions and ownership of work product, provision and removal of technical materials, and response to technology leakage"],
          ["IP Transactions & Monetization ", "technology transfer and licensing, joint development and commercialization, royalty structures, IP valuation, and investment linkage"],
          ["Domestic & International Enforcement and Disputes ", "infringement investigations, warning letters and negotiations, administrative trials and litigation, invalidity and design-around strategies, overseas enforcement, and coordination with local counsel"],
        ],
      },
      {
        title: "Global Expansion & Export Advisory",
        intro: "We advise technology companies on the legal and trade issues involved in entering overseas markets, structuring cross-border transactions, customs and clearance, export controls, and economic sanctions. Where local-law advice is required, we work with counsel in the relevant jurisdiction, while WEthePEOPLE remains responsible for communication with the Korean client and overall coordination of the engagement.",
        items: [
          ["Overseas Expansion & Investment Structures ", "local subsidiaries and branches, joint ventures and strategic alliances, governance, and coordination with local licensing, employment, and other specialists"],
          ["Cross-Border Transactions & Technology Business Agreements ", "international sales and purchases, distribution and dealership arrangements, OEM/ODM, international licensing, payment, guarantees, and logistics terms"],
          ["Korean Customs, Clearance & Refunds", "tariff classification, customs valuation and origin, FTAs, duty savings and refunds, customs audits, and administrative appeals"],
          ["Export Controls, Economic Sanctions & Supply-Chain Regulation ", "strategic goods and technology exports, sanctions screening, forced-labor and origin regulations, and local regulatory response"],
        ],
      },// 여기까지함
      {
        title: "U.S. Business & Litigation",
        intro: "We advise on U.S. market entry and business operations, customs and trade procedures, and technology and commercial disputes. WEthePEOPLE communicates directly with Korean clients and leads coordination with U.S. counsel, document preparation, and strategy development.",
        items: [
          ["U.S. Market Entry & Business Operations ", "entity and investment structures, commercial agreements, employment, privacy and compliance, and state-specific regulation"],
          ["U.S. Customs & Trade Procedures ", "tariff assessments and refunds, CBP administrative procedures, IEEPA and Section 201, 232 and 301 additional tariffs, and coordinated litigation before the U.S. Court of International Trade (CIT) and the U.S. Court of Appeals for the Federal Circuit"],
          ["Commercial, Technology & IP Litigation", "international contract, shareholder, product, and technology disputes; discovery and evidence preservation; arbitration and litigation; and joint representation with U.S. counsel"],
          ["U.S. Government Investigations & Regulatory Response", "investigations by the DOJ, FTC and other agencies; Hart-Scott-Rodino (HSR) filings and review; export-control and sanctions compliance; internal investigations and remediation"],
        ],
      },
    ],
    firmName: "WEthePEOPLE Law Group",
    address: "7F, Jinyang Building, 47 Gyeonggi-daero, Seodaemun-gu, Seoul",
    tel: "02-2101-0750",
    email: "wtp@wtplaw.co.kr",
  },
  techContactPage: {
    title: "Contact",
    lead: "Please complete the form below. The attorney responsible for your inquiry will review it and respond as promptly as possible.",
    nameLabel: "Name (Required)",
    namePlaceholder: "Jane Smith",
    companyLabel: "Company / Organization",
    companyPlaceholder: "Example: WEthePEOPLE Co., Ltd.",
    emailLabel: "Email (Required)",
    emailPlaceholder: "Example: name@company.com",
    phoneLabel: "Phone",
    phonePlaceholder: "010-0000-0000",
    urgentPhone: "+82-2-2101-0750",
    urgentPhoneHref: "tel:+82221010750",
    categoryLabel: "Practice Area",
    categories: ["Technology Company Advisory", "IP & Technology Rights", "Global Expansion & Exports", "U.S. Business & Litigation", "Competition & Platforms", "Employment & Labor", "Other"],
    messageLabel: "Inquiry (Required)",
    messagePlaceholder: "Please briefly describe the matter requiring review and the relevant background.",
    privacyText: "I agree to the collection and use of personal information for inquiry response purposes, retained for one year.",
    privacyLink: "View details",
    submitButton: "Send Inquiry",
    submittingButton: "Sending...",
    requiredMessage: "Name, email, inquiry details, and privacy consent are required.",
    successMessage: "Your inquiry has been received. We will respond as soon as possible.",
    errorMessage: "An error occurred while submitting your inquiry. Please try again later.",
    processTitle: "Inquiry Process",
    steps: [
      { title: "Inquiry Received", text: "Once you submit the form, the responsible team will review the matter." },
      { title: "Attorney Assigned", text: "We assign an attorney, patent attorney, or customs broker suited to the matter." },
      { title: "Response & Consultation", text: "We respond as promptly as possible after review and, where necessary, arrange an in-person or video consultation." },
    ],
    urgentTitle: "Is your matter urgent?",
    urgentText: "On weekdays from 09:00 to 18:00, we can connect you directly by phone with the attorney responsible for your matter.",
  },
  popup: {
    dontOpen: "Don’t show this again today",
    close: "Close",
  },
  slider: {
    insight: "Insights",
  },
  parter: {
    title: "Partners",
    sub: "Key Partners",
  },
};

export default En;
